import {
  type CommissionResponseBaseFragment,
  useGetCommissionsQuery,
} from '@/affiliate-dashboard/graphql';
import { Skeleton } from '@/components/base/skeleton';
import { useState } from 'react';
import invariant from 'tiny-invariant';
import { CommissionsTable } from './commissions-table/table';

const PAGE_SIZE = 10;

export function CommissionsTables({
  handlePageChange,
  data,
  totalPages,
  currentPage,
}: {
  handlePageChange: (newPage: number) => void;
  data: (CommissionResponseBaseFragment | null)[];
  totalPages: number;
  currentPage: number;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-10 pb-12">
      <CommissionsTable
        handlePageChange={handlePageChange}
        data={data}
        totalPages={totalPages}
        currentPage={currentPage}
      />
    </div>
  );
}

export function CommissionsTableWithData({
  userNumber,
}: {
  userNumber?: number;
}): JSX.Element {
  const [currentPage, setCurrentPage] = useState(0);

  const { data, loading } = useGetCommissionsQuery({
    variables: {
      limit: PAGE_SIZE,
      offset: currentPage * PAGE_SIZE,
      userNumber,
    },
    fetchPolicy: 'cache-and-network',
  });

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  if (loading) {
    return (
      <div className="mx-auto flex h-full w-full flex-col gap-4">
        <Skeleton className="h-full max-h-32 w-full rounded-xl" />
      </div>
    );
  }

  invariant(data, 'Data should be defined');

  const commissions = data?.commissions?.commissions ?? [];
  const totalPageCount = data?.commissions?.totalPageCount ?? 0;

  return (
    <div className="w-full">
      <CommissionsTables
        handlePageChange={handlePageChange}
        data={commissions}
        totalPages={totalPageCount}
        currentPage={currentPage}
      />
    </div>
  );
}
